import { createUserlist,createExternalUserlist } from "../../models/userlist.model";
import { createUserDetails } from "../../models/user-details.model";

export const externalUserState = {
  externalUserList: createExternalUserlist(),
  externalUserDetails: [],
};